module.exports = __webpack_public_path__ + "assets/day.a4e0f05d.svg";